const PAGE_NAME = {
  WORK: 1,
  ABOUT: 2,
}

export { PAGE_NAME };